import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, ExternalLink, Link2, Unlink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API, errText } from "@/lib/auth";
import { money } from "@/components/market/Shared";

export const ConnectForm = ({ ex, e, onDone }) => {
  const [keyId, setKeyId] = useState("");
  const [secret, setSecret] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async (ev) => {
    ev.preventDefault(); setBusy(true);
    try { const { data } = await axios.post(`${API}/auto/connect/${ex}`, { key_id: keyId, secret }); toast.success(`${e.name} connected · balance ${money(data.balance, 2)}`); setKeyId(""); setSecret(""); onDone(); }
    catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  const disconnect = async () => {
    if (!window.confirm(`Disconnect ${e.name}? Its bot goes back to paper.`)) return;
    await axios.delete(`${API}/auto/connect/${ex}`); toast.success("Disconnected"); onDone();
  };
  if (e.connected) return (
    <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3 flex flex-wrap items-center justify-between gap-2" data-testid={`connected-${ex}`}>
      <div className="flex items-center gap-2 text-sm"><CheckCircle2 className="w-4 h-4 text-emerald-400" />Connected <span className="text-slate-500 font-num text-xs">{e.key_hint}</span></div>
      <div className="font-num text-sm" data-testid={`balance-${ex}`}>{e.balance_error ? <span className="text-rose-300 text-xs">{e.balance_error}</span> : money(e.balance ?? 0, 2)}</div>
      <div className="flex gap-2 w-full">
        <a href={e.deposit} target="_blank" rel="noreferrer" className="btn-ghost flex-1 !h-10 text-xs" data-testid={`deposit-${ex}`}>Deposit / withdraw at {e.name}<ExternalLink className="w-3.5 h-3.5" /></a>
        <button onClick={disconnect} className="btn-ghost !h-10 text-xs" data-testid={`disconnect-${ex}`}><Unlink className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
  return (
    <form onSubmit={save} className="space-y-2" data-testid={`connect-form-${ex}`}>
      <p className="text-xs text-slate-400">{e.how}</p>
      <Input value={keyId} onChange={(x) => setKeyId(x.target.value)} placeholder="Key ID / key name" className="h-11 bg-[var(--bg)] border-[var(--line)] font-num text-xs" data-testid={`connect-key-${ex}`} />
      <textarea value={secret} onChange={(x) => setSecret(x.target.value)} placeholder="Private key / secret" rows={3} autoComplete="off" spellCheck={false}
        className="w-full rounded-xl bg-[var(--bg)] border border-[var(--line)] p-3 font-num text-xs outline-none focus:border-[var(--cyan)]" data-testid={`connect-secret-${ex}`} />
      <button disabled={busy || keyId.length < 4 || secret.length < 20} className="btn-primary w-full" data-testid={`connect-submit-${ex}`}><Link2 className="w-4 h-4" />{busy ? "Checking key…" : `Connect ${e.name}`}</button>
      <p className="text-[10px] text-slate-500">Your key is encrypted on our server and never shown again. Your money stays at {e.name}. We can't withdraw it.</p>
    </form>
  );
};
